<template>
    <div class="copy-wrapper">
        <button
            type="button"
            aria-label="copy number"
            @click="copyToClipboard(copyText)"
            class="badge-container-orange"
        >
            <img :src="require('@/assets/icons/copy.svg')" alt="copy number" />
            {{ translate("ui.copy.btn", "Copy")}}
        </button>
        <span v-if="showCopied" id="copy-message" class="copy-message">
            {{ translate("ui.copy.text", "Copied!")}}
        </span>
    </div>
</template>
<script>
import { toClipboard } from "@soerenmartius/vue3-clipboard";
import { ref } from "vue";
export default {
    name: "CopyButton",
    props: {
        copyText: {
            type: String,
            required: true,
        },
    },
    setup(){
        const showCopied = ref(false);
        function copyToClipboard(data) {
            toClipboard(data);
            showCopied.value = true;
            setTimeout(() => {
                showCopied.value = false;
            }, 700);
        }
        return{
            showCopied,
            copyToClipboard,
        };
    },
};
</script>
<style lang="scss" scoped>
.copy-message {
  margin-left: .7rem;
  font-size: 1.4rem;
  line-height: 1.3rem;
  color: #a6a6a6;
  position: absolute;
  animation: fade 0.2s ease;
  right: -90%;
}
.copy-wrapper{
  display: flex;
  position: relative;
}
@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.badge-container-orange {
  border: none;
  background: $primary-color;
  color: $white;
  border-radius: .3rem;
  display: inline-block;
  margin-left: 1.2rem;
  font-weight: $font-medium;
  font-size: .8rem;
  font-weight: bold;
  max-width: 4.95rem;
  width: 100%;
  line-height: 105%;
  text-transform: uppercase;
  padding: .5rem .6rem;
  margin: 0 0 0 1.5rem;
  cursor: pointer;
  img {
    padding-right: .5rem;
  }
}
</style>